import { Button } from '@chakra-ui/react';
import { reactEvents } from '@bridge/reactEvents';
import { useTranslation } from 'react-i18next';

interface Props {
  customerId?: number;
  conceptId?: number;
}

export function CreateArticleButton({ customerId, conceptId }: Props) {
  const { t } = useTranslation();

  return (
    <Button
      variant="entityDirectorySecondary"
      onClick={() =>
        reactEvents.routingChanged.dispatch({
          to: 'createArticle',
          navObj: { customerId, conceptId },
        })
      }
    >
      {t('general.newArticle')}
    </Button>
  );
}
